"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var id_1 = require("tsafe/id");
var useGuaranteedMemo_1 = require("powerhooks/useGuaranteedMemo");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var capitalize_1 = require("tsafe/capitalize");
var doExtends_1 = require("tsafe/doExtends");
var useDomRect_1 = require("powerhooks/useDomRect");
var responsive_1 = require("./lib/responsive");
var useMergeRefs_1 = require("./tools/useMergeRefs");
function createButton(params) {
    var Icon = (params !== null && params !== void 0 ? params : {
        "Icon": id_1.id(function () { return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, {}, void 0); }),
    }).Icon;
    var useStyles = ThemeProvider_1.makeStyles()(function (theme, _a) {
        var variant = _a.variant, disabled = _a.disabled, height = _a.height;
        var textColor = theme.colors.useCases.typography[disabled
            ? "textDisabled"
            : (function () {
                switch (variant) {
                    case "primary":
                        return "textFocus";
                    case "secondary":
                    case "ternary":
                        return "textPrimary";
                }
            })()];
        var hoverTextColor = (function () {
            switch (theme.isDarkModeEnabled) {
                case true:
                    return theme.colors.palette[(function () {
                        switch (variant) {
                            case "primary":
                                return "light";
                            case "secondary":
                            case "ternary":
                                return "dark";
                        }
                    })()].main;
                case false:
                    return theme.colors.palette.light.main;
            }
        })();
        return {
            "root": (function () {
                var hoverBackgroundColor = theme.colors.useCases.buttons[(function () {
                    switch (variant) {
                        case "primary":
                            return "actionHoverPrimary";
                        case "secondary":
                        case "ternary":
                            return "actionHoverSecondary";
                    }
                })()];
                return {
                    "textTransform": "unset",
                    "backgroundColor": disabled
                        ? theme.colors.useCases.buttons.actionDisabledBackground
                        : (function () {
                            switch (variant) {
                                case "primary":
                                case "secondary":
                                    return "transparent";
                                case "ternary":
                                    return theme.colors.useCases.surfaces
                                        .background;
                            }
                        })(),
                    "borderRadius": height === 0
                        ? theme.typography.rootFontSizePx
                        : height / 2,
                    "borderWidth": (function () {
                        switch (variant) {
                            case "primary":
                            case "secondary":
                                return 2;
                            case "ternary":
                                return 0;
                        }
                    })(),
                    "borderStyle": "solid",
                    "borderColor": disabled
                        ? "transparent"
                        : hoverBackgroundColor,
                    "padding": theme.spacing(2, (function () {
                        if (theme.responsive.windowInnerWidth >=
                            responsive_1.breakpointsValues.xl) {
                            return 3;
                        }
                        return 4;
                    })()),
                    "&.MuiButton-text": {
                        "color": textColor,
                    },
                    "&:hover": {
                        "backgroundColor": hoverBackgroundColor,
                        "& .MuiSvgIcon-root": {
                            "color": hoverTextColor,
                        },
                        "&.MuiButton-text": {
                            "color": hoverTextColor,
                        },
                    },
                };
            })(),
            "icon": {
                "color": textColor,
            },
        };
    });
    var Button = react_1.memo(react_1.forwardRef(function (props, forwardedRef) {
        var className = props.className, _a = props.variant, variant = _a === void 0 ? "primary" : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, children = props.children, startIcon = props.startIcon, endIcon = props.endIcon, _c = props.autoFocus, autoFocus = _c === void 0 ? false : _c, tabIndex = props.tabIndex, name = props.name, htmlId = props.htmlId, ariaLabel = props["aria-label"], 
        //For the forwarding, rest should be empty (typewise)
        rest = __rest(props, ["className", "variant", "disabled", "children", "startIcon", "endIcon", "autoFocus", "tabIndex", "name", "htmlId", "aria-label"]);
        var _d = useDomRect_1.useDomRect(), internalRef = _d.ref, height = _d.domRect.height;
        var ref = useMergeRefs_1.useMergeRefs([internalRef, forwardedRef]);
        var _e = useStyles({
            variant: variant,
            disabled: disabled,
            height: height,
        }), classes = _e.classes, cx = _e.cx;
        var IconWd = useGuaranteedMemo_1.useGuaranteedMemo(function () { return function (props) {
            return (jsx_runtime_1.jsx(Icon, { iconId: props.iconId, className: classes.icon, size: "default" }, void 0));
        }; }, [disabled, classes.icon]);
        return (jsx_runtime_1.jsx(Button_1.default, __assign({ ref: ref, className: cx(classes.root, className), 
            //There is an error in @material-ui/core types, this should be correct.
            disabled: disabled, startIcon: startIcon === undefined ? undefined : (jsx_runtime_1.jsx(IconWd, { iconId: startIcon }, void 0)), endIcon: endIcon === undefined ? undefined : (jsx_runtime_1.jsx(IconWd, { iconId: endIcon }, void 0)), autoFocus: autoFocus, tabIndex: tabIndex, name: name, id: htmlId, "aria-label": ariaLabel }, (function () {
            if ("onClick" in rest) {
                var onClick = rest.onClick, href = rest.href, restRest = __rest(rest, ["onClick", "href"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ onClick: onClick, href: href }, restRest);
            }
            if ("href" in rest) {
                var href = rest.href, _a = rest.doOpenNewTabIfHref, doOpenNewTabIfHref = _a === void 0 ? true : _a, restRest = __rest(rest, ["href", "doOpenNewTabIfHref"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ href: href, "target": doOpenNewTabIfHref
                        ? "_blank"
                        : undefined }, restRest);
            }
            if ("type" in rest) {
                var type = rest.type, restRest = __rest(rest, ["type"]);
                //For the forwarding, rest should be empty (typewise),
                doExtends_1.doExtends();
                return __assign({ type: type }, restRest);
            }
        })(), { children: typeof children === "string"
                ? capitalize_1.capitalize(children)
                : children }), void 0));
    }));
    return { Button: Button };
}
exports.createButton = createButton;
//# sourceMappingURL=Button.js.map